goog.provide("shadow.js.shim.module$$mui$material$List");
goog.provide("module$shadow_js_shim_module$$mui$material$List");
shadow.js.shim.module$$mui$material$List = shadow.js.nativeProvides["@mui/material/List"] = shadow$bridge("@mui/material/List");
module$shadow_js_shim_module$$mui$material$List.default = shadow.js.shim.module$$mui$material$List;
